import { Injector } from '@angular/core';
import { EntityServices } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Category, UIRouter } from '@uirouter/core';
// import { Visualizer } from '@uirouter/visualizer';
import { environment } from '../environments/environment';
// import { googleAnalyticsHook } from './util/ga';
import { routerHooks } from './router.hooks';
import { LoggingService } from './shared/services/logging/logging.service';

export function routerConfigFn(router: UIRouter, injector: Injector) {
    const log = injector.get(LoggingService);
    log.verbose('routerConfigFn');
    const store = injector.get(Store) as any;
    const transitionService = router.transitionService;
    const entityServices = injector.get(EntityServices);
    routerHooks(transitionService, log, store, entityServices);
    //   googleAnalyticsHook(transitionService);

    if (!environment.production) {
        router.trace.enable(Category.RESOLVE);
        router.trace.enable(Category.TRANSITION);
        router.trace.enable(Category.HOOK);
        router.trace.enable(Category.UIVIEW);
        router.trace.enable(Category.VIEWCONFIG);
        // router.plugin(Visualizer);
    }
}
